<template>
  <div class="ko-iko" style="position: relative">
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div style="position: absolute; right: 20px; top: 15px; z-index: 100" v-if="isLoading"><img style="vertical-align: middle" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="isDataLoaded">

      <form action="?">
        <div class="float-center w500">
        <label class="w100 tr fl" for="selectDate">{{ $t('ko.date_and_time') }}:</label>

        <select class="w150 fl" id="selectDate" v-model="selectedDate">
          <option v-for="date in listOfDates" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }}</option>
        </select>

          <div class="fl ml-2">
            <button type="button" :title="$t('ko.prev')" class="button w50 button-icon-only fl" @click="nextIndex()" :disabled="nextDisabled"><i class="icon-navigate_before"></i></button>
            <button type="button" :title="$t('ko.next')" class="button w50 button-icon-only fl" @click="prevIndex()" :disabled="prevDisabled"><i class="icon-navigate_next"></i></button>
            <button type="button" :title="$t('ko.refresh_txt')" @click="getData()" class="button w75 ml-2 fl">{{ $t('ko.refresh') }}</button>
            <div class="clearfix"></div>
          </div>

        </div>
        <div class="clearfix"></div>
      </form>

      <template v-if="selectedDate">

        <KoIKOTable v-if="stationsIkoShmu.length" :selected-date="selectedDate" :iko-stations="stationsIkoShmu" :header="$t('ko.shmu_stations')" :iko-data="selectedContentStations"></KoIKOTable>

        <KoIKOTable v-if="stationsIkoOther.length" :selected-date="selectedDate" :iko-stations="stationsIkoOther" :header="$t('ko.other_stations')" :iko-data="selectedContentStations"></KoIKOTable>

      </template>

    </div>


  </div>
</template>

<script>

import SHMUconf from '../shmu_conf';
import Axios from "axios";
import KoIKOTable from "./KoIKOTable";

export default {
  components: {
    KoIKOTable
  },
  name: 'KoIKO',
  props: {
  },
  data() {
    return {
      listOfDates: [],
      allStations: [],
      loadedData: [],
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isAllStationsLoaded: false,
      isDataLoaded: false,
      isLoading: false,
      selectedDate: null,
      iIndex: null,
      prevDisabled: false,
      nextDisabled: false,
    }
  },
  watch: {
    selectedDate(v) {

      let currentIndex = this.listOfDates.findIndex(item => item === v);
      let minIndex = 0;
      let maxIndex = this.listOfDates.length - 1;

      if (currentIndex <= minIndex) {
        this.prevDisabled = true;
      } else {
        this.prevDisabled = false;
      }

      if (currentIndex >= maxIndex) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }

    }
  },
  mounted() {
    this.getStations();

  },
  computed: {
    selectedDateIndex() {
      const sDate = this.selectedDate;
      return this.listOfDates.findIndex(item => item === sDate);

    },
    stationsIkoShmu() {
      return this.allStations.filter((station) => (parseInt(station.has_iko) === 1 && parseInt(station.type) === 1));
    },
    stationsIkoOther() {
      return this.allStations.filter((station) => (parseInt(station.has_iko) === 1 && parseInt(station.type) === 2));
    },

    selectedContentStations() {
      const self = this;
      const sDate = this.selectedDate;

      let iAllContent = [];

      if (sDate) {

        self.loadedData.forEach(function (v, i) {
          let r = v.data.find(item => item.dt === sDate);
          if (r) {
            iAllContent.push({
              station_id: v.station_id,
              data: r
            });
          }
        });
      }

      return iAllContent;

    },
  },
  methods: {
    getStations() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getstations', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {

          self.allStations = response.data;
          self.isAllStationsLoaded = true;
          self.isError = false;
          self.errorMsg = null;


          self.getData();


        } else {
          self.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní staníc kvality ovzdušia!';
          }
        }
        self.isLoading = false;
      }).catch((error) => {
        console.log(error);
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });


    },
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getikodata2?history=72', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {

          self.loadedData = response.data;

          if (self.loadedData .length) {

            let iAllDates = [];
            self.loadedData.forEach(function(v, i) {

              v.data.forEach(function(vv, ii) {
                if (iAllDates.indexOf(vv.dt) === -1) {
                  iAllDates.push(vv.dt);
                }
              });
            });

            iAllDates.sort((a,b) => (a > b) ? -1 : ((b > a) ? 1 : 0));
            self.listOfDates = iAllDates;

            if (self.listOfDates.length) {
              self.selectedDate = self.listOfDates[0];
            }

            self.isDataLoaded = true;
            self.isError = false;
            self.errorMsg = null;

          } else {
            self.isError = true;
            self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }



        } else {
          self.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        self.isLoading = false;
      }).catch((error) => {
        console.log(error);
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });

    },
    setIndex(index) {
      this.iIndex = index
    },
    prevIndex() {
      if (this.selectedDateIndex > 0) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex - 1];
      }
    },
    nextIndex() {
      if (this.selectedDateIndex < this.listOfDates.length - 1) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex + 1];
      }
    },

  }
}
</script>

